import Alpine from 'alpinejs'
import 'jquery';
import modules from './modules/modules.js';

if (!window.modules_loaded) {
	modules();
	window.Alpine = Alpine
	Alpine.start()
	window.modules_loaded = true
}

